// import { isLogin } from './tool';
import xhr from "./xhr";
import SESSION from "../config/login";
import * as storage from "./storage";

// 客户端如果未登录返回结果为-1
const sessionInfo = {
  time: null,
  sid: -1,
  st: -1
};

// 储存session
const saveSession = (sid, st) => {
  sessionInfo.sid = sid || -1;
  sessionInfo.st = st || -1;
  sessionInfo.time = Date.now();
};

// 返回当前缓存session
const getSessionInfo = () => {
  return sessionInfo;
};

// 从native获取session 因回调success也可能出现-1所以统一resolve
const getSession = () => {
  console.log("getSession");
  return new Promise(resolve => {
    const { getSession } = window.DN || {};
    if (getSession) {
      getSession({
        success: function(resp) {
          resp = JSON.parse(resp, 10);
          const { deviceId, tk } = resp;
          saveSession(deviceId, tk);
          return resolve(sessionInfo);
        },
        error: function() {
          saveSession(-1, -1);
          resolve(sessionInfo);
        }
      });
    } else {
      resolve(sessionInfo);
    }
  });
};

// 从native更新session(此方法目前只在goblin中调用,触发条件为访问业务接口下线)
const updateSession = () => {
  return new Promise(resolve => {
    const { updateSession } = window.DN || {};
    // if (!isLogin()) {
    //   // console.log('need login');
    //   resolve(sessionInfo);
    // } else {
    if (!updateSession) {
      return resolve(sessionInfo);
    }
    updateSession({
      success: function(resp) {
        resp = JSON.parse(resp, 10);
        const { deviceId, tk } = resp;
        saveSession(deviceId, tk);
        return resolve(sessionInfo);
      },
      error: function() {
        saveSession(-1, -1);
        resolve(sessionInfo);
      }
    });
    // updateSession({
    //   errorCode,
    //   ...sessionInfo
    // }).then(content => {
    //   console.log(content);
    //   // saveSession(sid, st);
    //   // return resolve(sessionInfo);
    // }).catch(() => {
    //   resolve(sessionInfo);
    // });
    // }
  });
};

// dev中网页login。
const getSessionByWeb = () => {
  return new Promise(resolve => {
    const st = storage.getLocal("sso_st") || -1;
    const sid = storage.getLocal("sso_sid") || -1;
    const { api, params } = SESSION;
    if (st !== -1 && sid !== -1) {
      saveSession(sid, st);
      resolve(sessionInfo);
    } else if (!params.account) {
      throw new Error("account not found");
    } else {
      xhr(api, params).then(resp => {
        const { deviceId, token } = resp.content;
        saveSession(deviceId, token);
        resolve(sessionInfo);
      });
    }
  });
};

const setSessionByWeb = () => {
  return new Promise((resolve) => {
    const st = storage.getLocal('token') || "";
    const sid = storage.getLocal('deviceId') || -1;
    saveSession(sid, st);
    resolve(sessionInfo);
  });
};

export { getSessionInfo, getSession, updateSession, getSessionByWeb, setSessionByWeb };
